import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 44, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.2 }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const MaskedLine = ({ children, delay = 0, className = "" }) => (
  <span className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
    <motion.span
      className={`block ${className}`}
      initial={{ y: "112%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const SectionHeading = ({ index, kicker, title, className = "" }) => (
  <Reveal className={className}>
    <div className="flex items-center gap-4 mb-5">
      <span className="font-mono text-xs tracking-[0.25em] text-brand-400">{index}</span>
      <span className="h-px w-12 bg-brand-500/60" />
      <span className="font-mono text-xs uppercase tracking-[0.25em] text-white/60">{kicker}</span>
    </div>
    <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.05]">
      {title}
    </h2>
  </Reveal>
);
